import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Enum } from 'app/model/enum';
import { Observable, forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DadosAuxilioTransporte } from 'app/service/dados-transporte-aba12/dados-auxilio-transporte.service';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.sass']
})
export class ModalDialogComponent implements OnInit {
  dialogRef: MatDialogRef<ModalDialogComponent>;
  dataSource: any;
  totalElements: number;
  pageSize: number;
  displayedColumns: string[] = [ 'id', 'codgLinhaPrefeitu', 'descLinha', 'acao' ];
  filterValue: string = '';
  isLoadingSpinner: boolean = false;
  pageNumber: number = 0;
  linhasTransportes: Enum[];
  selectedLine: any;
  dataSourceModal: any[];
  pageIndex = -1;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private dadosAuxilioTransporte: DadosAuxilioTransporte) {
    this.totalElements = data.totalElements;
    this.pageSize = data.pageSize;
  }
  
  ngOnInit(): void {
    this.processarEndereco()
  }

  
  private processarEndereco(): void {
    const verificar$: Observable<Enum[]> = this.verificaSeOUsuarioTemAuxilio();
    const pagina = this.pageIndex + 1; // pageIndex é baseado em zero, então adicionamos 1
    const tamanho = this.pageSize;
    const todasLinhasTransporte$: Observable<Enum[]> = this.getTodasLinhasTransporte(pagina, tamanho, '');

    forkJoin([verificar$, todasLinhasTransporte$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([verificar, todasLinhasTransporte]) => {
          // Manipular os dados do endereço e UFs aqui
          //this.buscarTipoLogradouro()
          //this.buscarMunicipio();
          this.atualizarFormulario(verificar, todasLinhasTransporte);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }
  private verificaSeOUsuarioTemAuxilio(): Observable<any> {
    return this.dadosAuxilioTransporte.getVerificaSeOUsuarioTemAuxilio();
  } 
  private atualizarFormulario(verificar: any, todasLinhasTransporte: Enum[]): void {
 
    this.dataSourceModal = todasLinhasTransporte['content'];
    this.linhasTransportes = todasLinhasTransporte
    this.totalElements = todasLinhasTransporte['totalElements'];
    // Configurar o paginator e sort após obter os dados
    //this.dataSource.sort = this.sort;
  }
  applyFilter(value: string) {
    const começaComNúmero = /^\d/.test(value);
   
    if(começaComNúmero == false) {
      const formattedValue = value.trim().toLowerCase();
      this.filterValue = formattedValue.toUpperCase()
    } else this.filterValue = value

    const todasLinhasTransporte$: Observable<Enum[]> = this.getTodasLinhasTransporte(0, this.pageSize, this.filterValue);

    forkJoin([todasLinhasTransporte$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([todasLinhasTransporte]) => {
          this.atualizarLinhasComFiltro(todasLinhasTransporte);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }
  onPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getTodasLinhasTransporte(this.pageNumber, this.pageSize, this.filterValue).subscribe(response => {
      this.linhasTransportes = response.content;
      this.dataSourceModal = this.linhasTransportes
      this.totalElements = response.totalElements;
    });
  }

  private getTodasLinhasTransporte(pagina, tamanho, filtro): Observable<any> {
    return this.dadosAuxilioTransporte.getTodasLinhasTransporte(pagina, tamanho, filtro)
  }

  private atualizarLinhasComFiltro(todasLinhasTransporte) {
    this.linhasTransportes = todasLinhasTransporte['content'];
    this.dataSourceModal = this.linhasTransportes
    this.totalElements =  todasLinhasTransporte['totalElements'];
  }
  
  selectLine(id: number, codgLinhaPrefeitu: number, descLinha: string) {
    this.selectedLine = { id: id, codgLinhaPrefeitu: codgLinhaPrefeitu, descLinha: descLinha };
    this.dialogRef.close(this.selectedLine);
  }
  
}
